import { useEffect } from 'react';

export function useFavicon(href: string) {
    useEffect(() => {
        const existing = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
        const link = existing ?? document.createElement('link');

        if (!existing) {
            link.rel = 'icon';
            document.head.appendChild(link);
        }

        link.href = href;

        return () => {
            link.href = '/favicon.ico';
        };
    }, [href]);
}
